import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useChapterCreate } from '@/module/Author/Chapter/model/ChapterQuery';
import { ChapterSchema, chapterSchema, defaultChapterValues } from '@/module/Author/Chapter/model/ChapterSchema';
import { Chapter } from '@/module/Author/Chapter/model/ChapterTypes';
import { ImportItem } from '@/module/Sync/model/SyncTypes';

import { dangerouslyConvertType, useAppNotification } from '@feature/utils';

import { ChapterForm } from './ChapterForm';

interface ChapterSyncProps {
  onSuccess: (chapter: Chapter) => void;
  item: ImportItem;
  onCancel: () => void;
  sourceType: string;
}

function convert(item: ImportItem, sourceType: string): ChapterSchema {
  return dangerouslyConvertType<ChapterSchema>({
    ...item,
    bdis: [],
    wosCategories: [],
    wosIndexes: [],

    language: null,
    type: null,
    sourceType,
  });
}

export function ChapterSync({ onSuccess, item, onCancel, sourceType }: ChapterSyncProps) {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useChapterCreate();
  const notification = useAppNotification();

  const onSubmit = (values: ChapterSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newChapter => {
        notification.success();
        onSuccess(newChapter);
      },
    });
  };

  return (
    <>
      <Text>{item.publisherName}</Text>
      <ChapterForm
        title={t('chapters.form.title.create')}
        schema={chapterSchema}
        defaultValues={defaultChapterValues}
        values={convert(item, sourceType)}
        isSubmitting={isPending}
        isError={isError}
        isSuccess={isSuccess}
        onSubmit={onSubmit}
        onCancel={onCancel}
        showWosFields={false}
        showScopusFields={false}
      />
    </>
  );
}
